import React, { useEffect, useContext, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { api } from "../lib/api";
import { AuthContext } from "../App";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const { refresh } = useContext(AuthContext);
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const hash = location.hash || window.location.hash;
    const params = new URLSearchParams(hash.replace(/^#/, ""));
    const sessionId = params.get("session_id");
    if (!sessionId) {
      navigate("/admin/login", { replace: true });
      return;
    }
    (async () => {
      try {
        const res = await api.post("/auth/session", { session_id: sessionId });
        // Clear the hash
        window.history.replaceState(null, "", window.location.pathname);
        await refresh();
        if (res.data?.is_admin) navigate("/admin", { replace: true });
        else navigate("/admin/login", { replace: true, state: { forbidden: true } });
      } catch {
        navigate("/admin/login", { replace: true });
      }
    })();
  }, [location, navigate, refresh]);

  return (
    <div className="min-h-screen flex items-center justify-center" data-testid="auth-callback">
      <div className="text-center">
        <div className="font-cinzel text-[0.65rem] tracking-[0.5em] text-[color:var(--jk-gold)] mb-3">— AUTHENTICATING</div>
        <div className="font-cinzel text-xl">Signing you in...</div>
      </div>
    </div>
  );
}
